import styles from './collectionUtils.module.scss';

export const EMPTY_CELL = <span className={styles['empty-cell']}>{'–'}</span>;
